class TrackEquipmentMapsRouter extends App.Routers.BaseRouter {
    constructor() {
        const entityName = 'TrackEquipmentMaps';

        super(entityName);

        this.closeActions = [];

        App.Objects = App.Objects || {};
        App.Forms = App.Forms || {};

        var paginateOptions = Monet.Grid.Utils.paginationOptions;

        if (Monet.Session.TrackEquipmentMaps) {
            Monet.Session.TrackEquipmentMaps.idEquipment = null;
        }

        if (App.Views.TrackEquipmentMaps) {
            App.Views.TrackEquipmentMaps.equipment = {};
        }

        App.Objects.TrackEquipmentMaps = this;
        App.Forms.TrackEquipmentMaps = {
            table: null,
            dataProvider: null,
            pagination: {
                first: paginateOptions.FIRST,
                max: paginateOptions.MAX_RESULT,
                blocked: false,
                canIncrement: true
            }
        };
    }

    show = (idEquipment, eventId) => {
        try {
            this.eventId = eventId;
            const contentHtml = document.querySelector("#TrackEquipmentMaps");

            if (contentHtml) {
                document.getElementById("TrackEquipmentMaps").innerHTML = "";
                Monet.Session.TrackEquipmentMaps = {
                    "map": null,
                    equipment: {id: idEquipment},
                    shouldOpenPopup: true,
                    isComingFromEquipmentLink: false
                };

                Monet.Session.TrackEquipmentMaps.events = []
                Greenmile.TrackEquipment.Utils.createLayout(contentHtml);

                this.initializeMap();
                App.Views.TrackEquipmentMaps.showFilter();

                this.requestNewTruck(idEquipment, this.eventId);

                contentHtml.appendChild(Greenmile.Templates.getCaptionArrowStatusTruck());
                App.Forms.TrackEquipmentMaps.form.fields.organization.postRender();

                const le = document.querySelector('#TrackEquipmentMaps #track-equipment-caption'),
                    grid = document.querySelector('#TrackEquipmentMaps #tabsRouteDetail');

                le.style.bottom = parseInt(grid.getBoundingClientRect().height) + 25 + "px";
            }
        } catch (e) {
            const error = new Monet.Exception.ReturnError(this, "Error on show equipments map", e);
            error.console();
        }
    }

    requestEventsAndCoordsByDataRange = (equipmentId, eventId) => {
        const interval = App.Views.TrackEquipmentMaps.getDateTimeInterval('#TrackEquipmentMaps');
        const equipment = {
            id: equipmentId,
            idOfObject: equipmentId,
            timeStart: interval.timeStart,
            timeEnd: interval.timeEnd
        };

        App.Views.TrackEquipmentMaps.equipment = equipment;
        App.Views.TrackEquipmentMaps.events = new Greenmile.EventLog.Manager(null, equipment);
        App.Views.TrackEquipmentMaps.events.eventId = eventId;
        App.Views.TrackEquipmentMaps.clearEquipmentRoute();

        const storage = new Greenmile.Storage.StoreMapPosition();
        const check = storage.getLayerMapFromUser();

        Monet.Session.TrackEquipmentMaps.openEventPopup = () => {
            const { map, shouldOpenPopup } = Monet.Session.TrackEquipmentMaps;
            if ((eventId || map.eventId) && shouldOpenPopup) {
                map.eventId = eventId;
                for (const key in map._layers) {
                    const layer = map._layers[key];
                    if (layer.kind === 'EVENT' && String(layer.id) === `TrackEquipmentMaps_${eventId}`) {
                            layer.openPopup();
                            Monet.Session.TrackEquipmentMaps.shouldOpenPopup = false;
                        return;
                    }
                }
            }
        };

        const callbackAddEvents = () => {
            const eventLogManager = App.Views.TrackEquipmentMaps.events;
            const { map, events } = Monet.Session.TrackEquipmentMaps;
            const callback = () => {
                setTimeout(Monet.Session.TrackEquipmentMaps.openEventPopup, 600);
            };

            eventLogManager.cleanMarkerEvent(map);
            eventLogManager.addEventsOnMap(map, events, 'TrackEquipmentMaps', callback);
        };

        Monet.Session.TrackEquipmentMaps.updateEventLog = function () {
            App.Views.TrackEquipmentMaps.events.requestEvent({
                callback: callbackAddEvents,
                eventId
            });
        };

        if (check.event_equipment || eventId) {
            Monet.Session.TrackEquipmentMaps.updateEventLog();
        }

        var request = new Greenmile.TrackEquipment.Request();
        request.getEquipmentActualPath(equipment, interval.timeStart, interval.timeEnd);
    }

    requestNewTruck = (idEquipment) => {

        this.requestEventsAndCoordsByDataRange(idEquipment, this.eventId);

        if(App.Forms.TrackEquipmentMaps.form ) {
            App.Forms.TrackEquipmentMaps.form.clearAllFields();
        }

    }

    updateRouteInfo = () => {
        if (Monet.Session.TrackEquipmentMaps && Monet.Session.TrackEquipmentMaps.coordinates) {

            setTimeout(function () {

                const equipment = {};
                const map = Monet.Session.TrackEquipmentMaps.map;
                const positionSources = Monet.Session.TrackEquipmentMaps.positionSources;
                const equipmentId = App.Views.TrackEquipmentMaps.equipment.id;

                App.Views.TrackEquipmentMaps.clearEquipmentRoute();

                const option = {
                    sourceSessionData: Monet.Session.TrackEquipmentMaps
                };

                const cDistance = new Greenmile.Toolbar.Map.DistanceBetweenCoords(undefined, map, option);
                const infoRoute = new Greenmile.Coordinates.GeneralFunctions(Monet.Session.TrackEquipmentMaps);
                const options = {
                    kind: 'TRACK_EQUIPMENT',
                    eventToClickArrow: (e) => {
                        cDistance.markerClickHandler(e);
                    }
                };

                const pathColors = ['#FF41A6', '#FF7D00'];
                positionSources?.models.forEach((positionSource, index) => {
                  const positionSourceCoordinates =
                    positionSource.get('coordinates');
                  options.color = pathColors[index];

                  infoRoute.generateActualRouteInfo(
                    map,
                    positionSourceCoordinates,
                    options,
                    equipmentId
                  );
                });


                const lastCoordinate = positionSources?.at(0).get('coordinates').last();
                if(lastCoordinate) {
                    equipment.speedKmh = lastCoordinate.get('speedKmh');
                    equipment.equipmentKey = lastCoordinate.get('equipmentKey');
                    equipment.idOfObject = equipmentId;
                    Greenmile.RouteDetail.Util.addTruckMarkerToMap(lastCoordinate, equipment, Monet.Session.TrackEquipmentMaps, 'PRINCIPAL_EQUIPMENT');
                }

            }, 10);
        }
    }

    initializeMap = () => {
        var error = null;

        try {
            var selector = "#TrackEquipmentMaps  #mapToolbar";
            var mapConfs = Greenmile.Map.Utility.getMapLocalStorageConfiguration();
            var screen = Monet.Session.TrackEquipmentMaps;

            const map = Greenmile.Map.Utility.createDefaultMap("trackEquipmentMapContainer");

            if (this.eventId) {
              map.eventId = this.eventId;
            }

            const baseLayer = Greenmile.Map.Utility.createBaseLayer();

            map.addLayer(baseLayer);


            Monet.Session.TrackEquipmentMaps.name = 'TrackEquipmentMaps';
            Monet.Session.TrackEquipmentMaps.map = map;
            Monet.Session.TrackEquipmentMaps.mapBaseLayer = baseLayer;
            Monet.Session.TrackEquipmentMaps.routeLayer = undefined;
            Monet.Session.TrackEquipmentMaps.canShowLayerCoordinates = true;
            Monet.Session.TrackEquipmentMaps.canMakeCoordinates = true;
            Monet.Session.TrackEquipmentMaps.player = {
                isPlaying: false,
                currentMarkerIndex: 0
            };

            map.on('zoomend', this.updateRouteInfo);

            var eventEquipment = new Greenmile.TrackEquipment.EventEquipment(map);
            var options = {
                sourceSessionData: screen, // responsavel por guardar as informações gerais de si proprio com objetivo de ser usado em algum momento a frente
                routePlay: {
                    beforeStartPlay: () => {
                      this.updateRouteInfo();
                    },
                    afterChangeDate: () => {
                        const data = App.Views.TrackEquipmentMaps;
                        this.requestEventsAndCoordsByDataRange(data.equipment.id, data.events.eventId);
                    }
                },
                layersToEnable: [{
                    'layer': Greenmile.Toolbar.MapLayers.EVENT_EQUIPMENT,
                    'instanceDataClass': eventEquipment
                }],
                equipmentOff: {
                    onClickFilter: (coordinatesFiltered) => {
                        new Greenmile.Marker.EquipmentInOff(map).setData(coordinatesFiltered).render();
                    }
                }
            };

            screen.toolbarSelector = selector;

            var title = Monet.I18n.getResourcesByKey('Greenmile.TrackEquipment.screenName');
            var helper = new Monet.UI.Help('TrackEquipmentMapsDisplay', title);
            var toolbar = new Greenmile.Toolbar.Map(map, screen.toolbarSelector, options, helper);

            toolbar.enable([
                toolbar.actions.searchAddressOnMap,
                toolbar.actions.street,
                toolbar.actions.points,
                toolbar.actions.coords,
                toolbar.actions.fitToMarkers,
                toolbar.actions.focusEquipment,
                toolbar.actions.zoom,
                toolbar.actions.source,
                toolbar.actions.routePlayer,
                toolbar.actions.equipmentOff,
                toolbar.actions.layer,
                toolbar.actions.geofences
            ]);

            toolbar.render();

            var request = new Greenmile.TrackEquipment.Request();
            request.renderTelematicChart();
            this.addEventListenners();
            var preferences = new Greenmile.Storage.StoreMapPosition().getTrackEquipmentPreferencies();

            if (preferences && typeof preferences.showTabs !== "undefined" && !preferences.showTabs) {
                this.hideTabInformation('#TrackEquipmentMaps');
            } else {
                this.showTabInformation('#TrackEquipmentMaps');
            }

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "Error on initialize track equipment map", e);
            error.console();

        }
    }

    getFilter = () => {

        return App.Forms.TrackEquipmentMaps.createFilter.getValuesAndFormatJson();
    }

    updateGrid = (filter, callback) => {

        var request = new Greenmile.TrackEquipment.Request();
        request.getEquipments(filter, callback);
    }

    hideTabInformation = (screenTab) => {
        const btnHide = document.querySelector(`${screenTab} #btnHideGridStop`);

        const tab = document.querySelector(`${screenTab} #tabsRouteDetail`);
        const statusTruck = document.querySelector(`${screenTab} #track-equipment-caption`);
        const miniPlayer = document.querySelector(`${screenTab} div.miniPlayer`);
        const storage = new Greenmile.Storage.StoreMapPosition();
        const preferences = storage.getTrackEquipmentPreferencies();

        if (tab !== null) {
            tab.style.display = "none";
        }

        if (statusTruck) {
            statusTruck.style.bottom = 5 + "px";
        }

        btnHide.style.display = "none";
        miniPlayer.style.display = "block";

        App.Views.TrackEquipmentMaps.adjustHeightMap();

        preferences.showTabs = false;
        storage.setTrackEquipmentPreferencies(preferences);


    }

    showTabInformation = (screenTab) => {

        var btnHide = document.querySelector(screenTab + " #btnHideGridStop");
        var tab = document.querySelector(screenTab + " #tabsRouteDetail");
        var miniPlayer = document.querySelector(screenTab + " div.miniPlayer");
        var statusTruck = document.querySelector(screenTab + " #track-equipment-caption");
        var storage = new Greenmile.Storage.StoreMapPosition();
        var preferences = storage.getTrackEquipmentPreferencies();

        if (tab) {
            tab.style.display = "block";
        }

        if (statusTruck) {
            statusTruck.style.bottom = parseInt(tab.getBoundingClientRect().height) + 10 + "px";
        }

        btnHide.style.display = "block";
        miniPlayer.style.display = "none";

        App.Views.TrackEquipmentMaps.adjustHeightMap();

        preferences.showTabs = true;
        storage.setTrackEquipmentPreferencies(preferences);

    }

    addEventListenners = () => {
        var screenTab = '#TrackEquipmentMaps';

        var btnHide = document.querySelector(screenTab + " #btnHideGridStop");
        var btnShow = document.querySelector(screenTab + " #miniPlayer");

        var hideTabs = this.hideTabInformation;
        var showTabs = this.showTabInformation;

        var hideTabInformation = function () {
            return hideTabs(screenTab);
        };

        var showTabInformation = function () {
            return showTabs(screenTab);
        };

        if (btnHide) {
            btnHide.removeEventListener("click", hideTabInformation);
            btnHide.addEventListener("click", hideTabInformation);
        }

        if (btnShow) {
            btnShow.removeEventListener("click", showTabInformation);
            btnShow.addEventListener("click", showTabInformation);
        }
    }

    addCloseAction = (action) => {
        this.closeActions.push(action);
    }

    removeCloseAction = (actionToRemove) => {
        this.closeActions = this.closeActions.filter((action) => action !== actionToRemove);
    }

    onClose = () => {
        this.closeActions.forEach((action) => action());

        if (Monet.Session.TrackEquipmentMaps) {
            Monet.Session.TrackEquipmentMaps.map && Monet.Session.TrackEquipmentMaps.map.remove();
            Monet.Session.TrackEquipmentMaps = {};
        }

        if (App.Views.TrackEquipmentMaps) {
            App.Views.TrackEquipmentMaps.equipment = {};
        }
    }
}

App.Routers.TrackEquipmentMaps = TrackEquipmentMapsRouter;
